import "core-js/modules/es.date.to-string.js";
function a(e, n) {
  var r = new URL(e);
  return Object.keys(n).forEach(function (t) {
    typeof n[t] > "u" || r.searchParams.append(t, n[t]);
  }), r.toString();
}
function c(e, n, r, t) {
  var u = {
    utm_medium: n
  };
  return r && (u.utm_source = r), t && (u.utm_campaign = t), a(e, u);
}
export { a as addUrlParams, c as addUtmParams };